import Invitation from 'app/scripts/models/invitation.coffee';

class OrganizationInvitation extends Invitation {
  static initClass() {
    this.prototype.typeName = 'OrganizationInvitation';
  }
}
OrganizationInvitation.initClass();

export { OrganizationInvitation };
